export default __webpack_public_path__ + "06f967bbd162615bb39a7cf3fe78dbd4.png";